import { render } from "./DepartmentDetailsView.vue?vue&type=template&id=1cfda01c&scoped=true&ts=true"
import script from "./DepartmentDetailsView.vue?vue&type=script&lang=ts"
export * from "./DepartmentDetailsView.vue?vue&type=script&lang=ts"

import "./DepartmentDetailsView.vue?vue&type=style&index=0&id=1cfda01c&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cfda01c"]])

export default __exports__